import React from 'react';
import {
  Dialog,
  DialogContent,
} from './ui/dialog';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const ClaimSubmittedModal = ({ isOpen, onFinish, claimId }) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-[500px] bg-white" hideClose>
        <div className="py-8 px-4 text-center">
          <p className="text-2xl font-semibold text-green-600 mb-8">
            New Claim {claimId} is submitted.
          </p>
          
          <div className="flex justify-center">
            <Button 
              onClick={onFinish}
              className="bg-transparent hover:bg-blue-50 text-blue-500 border-none shadow-none text-xl"
            >
              Finish
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClaimSubmittedModal;
